import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-testimonial-carousel',
  templateUrl: './testimonial-carousel.component.html',
  styleUrls: ['./testimonial-carousel.component.css']
})
export class TestimonialCarouselComponent implements OnInit {

  testimonials = [
    /* {
      name: 'Maria José',
      career: 'Consultora',
      studies: 'Máster en Projectos',
      university: 'EAE',
      testimonial: 'Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime placeat',
      imageUrl: 'https://images.unsplash.com/photo-1588361035994-295e21daa761?crop=entropy&cs=tinysrgb&fit=crop&fm=jpg&h=301&ixid=eyJhcHBfaWQiOjF9&ixlib=rb-1.2.1&q=50&w=301',
    }, */
    {
      name: 'Iván G',
      career: 'Ingeniero Industrial',
      studies: 'Máster en Management',
      university: 'EAE',
      testimonial: '"Era el servicio que buscaba, y el precio se adaptaba a mis necesidades. Me inspiraron confianza con la experiencia que tienen viviendo y trabajando en Europa. Estoy contento y agradecido de haber reservado con ellos ya que me facilitaron todo el proceso!"',
      spriteClass: 'testimonialivanGuerraPeq',
      year: ''
    },
    {
      name: 'Andrés P',
      career: 'Project Manager & Marketing',
      studies: 'Máster en Mercadeo con Dirección de Empresas',
      university: 'EUDE',
      testimonial: '"Desde el primer momento me transmitieron mucha confianza al ser jóvenes y profesionales activos en España, y con la experiencia que ya tienen viviendo en Europa. Tienen amplio conocimiento de los procesos a seguir y han documentado todo muy bien! Lo recomendaría 100%."',
      spriteClass: 'testimonialandresPrietoPeq',
      year: ''
    },
    {
      name: 'Giancarlo',
      studies: 'Máster en Fisioterapia',
      university: 'UPM',
      testimonial: 'Me facilitaron todos los procesos incómodos relacionados a extranjería, me ayudaron a adaptarme y me ahorraron bastantes disgustos. Sinceramente creo que fue la mejor decisión solicitar consejos ya que al principio tenía muchas dudas que al final pude resolver.',
      spriteClass: 'testimonialgiancarloLucarPeq',
      year: ''
    },
    {
      name: 'Alejandro Cedeño',
      career: 'Ingeniero Civil',
      studies: 'Máster en Arquitectura, Diseño y Administración de empresas',
      university: 'UIC',
      spriteClass: 'testimonialalecedePeq',
      testimonial: 'Fueron clave en los procesos de extranjería cuando llegué a España. La información suele estar muy dispersa y pero con la ayuda de ellos pude organizarmme mejor y cumplir con todos los plazos para no tener ningún problema.',
      imageUrl: 'https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/8ea44043-a792-4892-6c42-e39df8897900/public',
      year: '2023'
    },
/*     {
      name: 'Melissa Álvarez',
      career: '',
      studies: '',
      university: '',
      testimonial: '',
      imageUrl: 'https://i.ibb.co/8x9xK4H/team.jpg',
      year: ''
    },
    {
      name: 'Eric Rojas',
      career: '',
      studies: '',
      university: '',
      testimonial: '',
      imageUrl: 'https://i.ibb.co/8x9xK4H/team.jpg',
      year: ''
    } */
  ];

  constructor() { }

  ngOnInit(): void {
  }

}
